module.exports = __webpack_public_path__ + "static/media/cwaitCheck.63e153ac.svg";